import { RemoteGetAllPlacesFromGroup } from 'data/usecases';
import { GetAllPlacesFromGroupUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPlacesFromGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllPlacesFromGroup =
  (): GetAllPlacesFromGroupUseCaseInterface =>
    new RemoteGetAllPlacesFromGroup(
      makeApiUrlPlacesFromGroup(),
      makeAxiosHttpClient(),
    );
